import { useRef, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import firebase, { db } from '../../../../constants/firebase';
import { addLocation } from '../../../../data/Locations'
import { LocationSchema } from '../../../../data/Validation/LocationSchema';
import { FormikSelect } from '../../../Features/FormInputs/FormikSelect';
import { getGeoCode } from '../../../../data/Locations/getGeoCode';
import { setGeoPoint } from '../../../../data/Locations/setGeoPoint';


export const AddLocation = (props) => {
    const queryClient = useQueryClient()
    const navigate = useNavigate()
    const formRef = useRef();
    const [coords, setCoords] = useState('Please generate coordinates for this location')
    const [docRef, setDocRef] = useState(null)


    const handleClick = (async () => {
        const addressString = `${formRef.current.values.street} ${formRef.current.values.city} ${formRef.current.values.state} ${formRef.current.values.zip}`
        const geoCode = await getGeoCode(addressString)
        const newLocation = new firebase.firestore.GeoPoint(geoCode.results[0].geometry.location.lat, geoCode.results[0].geometry.location.lng)
        setCoords(`${geoCode.results[0].geometry.location.lat}, ${geoCode.results[0].geometry.location.lng}`)
        setGeoPoint(docRef, newLocation)

    })

    const createLocation = useMutation(locationInfo => addLocation(locationInfo))

    useEffect(() => {
        setDocRef(db.collection('locations').doc().id)
    }, [])

    return (
        <div className="bg-white shadow rounded-lg divide-y divide-gray-200">
            <div className="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
                <div className="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                        <h1 className="text-lg leading-6 font-large text-gray-900">
                            Add Location
                        </h1>
                    </div>
                </div>
            </div>
            <div className="flex flex-row">
                <div className="space-y-8 py-6 px-6 flex-1">
                    <div className="space-y-8">
                        <div className="mt-6">
                            <Formik
                                innerRef={formRef}
                                initialValues={{
                                    name: '',
                                    street: '',
                                    city: '',
                                    state: '',
                                    zip: '',
                                    coords: coords,
                                    hours: '',
                                    phone: '',
                                    type: '',
                                }}
                                validationSchema={LocationSchema}
                                onSubmit={(values, { setSubmitting }) => {
                                    const data = {
                                        name: values.name,
                                        street: values.street,
                                        city: values.city,
                                        state: values.state,
                                        zip: values.zip,
                                        hours: values.hours,
                                        phone: values.phone,
                                        type: values.type,
                                    }
                                    const locationInfo = { ...data, docRef }
                                    createLocation.mutate(locationInfo)
                                    queryClient.invalidateQueries('locations')
                                    navigate('../')
                                }}
                            >
                                {({ isSubmitting, errors, touched, values }) => (
                                    <Form>
                                        <div className="">
                                            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                                                Location Name
                                            </label>
                                            <div className="mt-1 flex rounded-md shadow-sm">
                                                <Field type="text" name="name" id="name" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.name ? 'border-red' : ''}`} />
                                                <ErrorMessage name="name" component="div" className="text-red" />
                                            </div>
                                        </div>
                                        <div className="">
                                            <label htmlFor="street" className="block text-sm font-medium text-gray-700">
                                                Street Address
                                            </label>
                                            <div className="mt-1 flex rounded-md shadow-sm">
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <Field type="text" name="street" id="street" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.street ? 'border-red' : ''}`} />
                                                    <ErrorMessage name="street" component="div" className="text-red" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-row space-x-6">
                                            <div className="">
                                                <label htmlFor="city" className="block text-sm font-medium text-gray-700">
                                                    City
                                                </label>
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <div className="mt-1 flex rounded-md shadow-sm">
                                                        <Field type="text" name="city" id="city" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.city ? 'border-red' : ''}`} />
                                                        <ErrorMessage name="city" component="div" className="text-red" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="">
                                                <label htmlFor="state" className="block text-sm font-medium text-gray-700">
                                                    State
                                                </label>
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <div className="mt-1 flex rounded-md shadow-sm">
                                                        <Field type="text" name="state" id="state" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.state ? 'border-red' : ''}`} />
                                                        <ErrorMessage name="state" component="div" className="text-red" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="">
                                                <label htmlFor="zip" className="block text-sm font-medium text-gray-700">
                                                    ZIP
                                                </label>
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <div className="mt-1 flex rounded-md shadow-sm">
                                                        <Field type="text" name="zip" id="zip" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.zip ? 'border-red' : ''}`} />
                                                        <ErrorMessage name="zip" component="div" className="text-red" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <GetCoords coords={coords} setCoords={setCoords} errors={formRef.current?.errors} formRef={formRef} /> */}
                                        <div className="">
                                            <label htmlFor="coords" className="block text-sm font-medium text-gray-700">
                                                Coordinates
                                            </label>
                                            <div className='flex flex-row'>
                                                <button type="button" onClick={e => handleClick(e)} className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-dkpurple hover:bg-ltpurple hover:text-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                    Generate Coordinates
                                                </button>
                                                <div className="mt-1 ml-4 flex rounded-md shadow-sm">
                                                    <div className="mt-1 flex rounded-md shadow-sm">
                                                        <Field type="text" name="coords" id="coords" value={coords} className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-96 min-w-0 rounded-none rounded-r-md sm:text-sm text-black `} />
                                                        <ErrorMessage name="coords" component="div" className="text-red" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <label htmlFor="zip" className="block text-sm font-medium text-gray-700">
                                                Hours
                                                </label>
                                            <div className="mt-1 flex rounded-md shadow-sm">
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <Field type="text" name="hours" id="hours" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.hours ? 'border-red' : ''}`} />
                                                    <ErrorMessage name="hours" component="div" className="text-red" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <label htmlFor="zip" className="block text-sm font-medium text-gray-700">
                                                Phone
                                                </label>
                                            <div className="mt-1 flex rounded-md shadow-sm">
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <Field type="text" name="phone" id="phone" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.phone ? 'border-red' : ''}`} />
                                                    <ErrorMessage name="phone" component="div" className="text-red" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <FormikSelect label="Type: " name="type" className="mt-2">
                                                <option value="">Select a type</option>
                                                <option value="emergency">Emergency</option>
                                                <option value="shelter">Shelter</option>
                                                <option value="safeplace">Safe Place</option>
                                            </FormikSelect>
                                        </div>
                                        {coords === 'Please generate coordinates for this location' ?
                                            null
                                            :
                                            <button type="submit" className="relative inline-flex items-center my-6 px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-dkpurple hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                Save Changes
                                            {/* {isLoading ? 'Updating location...' : isError ? 'Error!' : isSuccess ? 'Location Updated' : 'Save Changes'} */}
                                            </button>
                                        }
                                    </ Form>
                                )}
                            </ Formik>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}